import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { generateURL } from '../../routes/index';
import { formatNumber, DateFormatter } from '../../utils/date';
import { Link } from 'react-router';
import forEach from 'lodash/forEach';
import { fetchEditorialsFromType } from '../../actions/editorials';
import connect from '../../utils/connect';
import Spinner from '../../components/svg/spinner';
import Select from '../form/select/select';
import css from './contextualEditorials.scss';
import translate from '../../utils/translate';

class ContextualDefault extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.state = {
			searchWord: '',
			searchResults: [],
			searched: false,
			busy: false,
			clearData: false,
			start: 0,
			end: 0,
			active: false,
		};

		this.editorialsByType = [];
		this.years = [];
		this.introHidden = false;
		this.firstLaunch = true;
	}

	componentWillMount() {
		if (this.props.enableNews) {
			this.fetchEditorialsFromType = bindActionCreators(fetchEditorialsFromType, this.props.dispatch);
			this.fetchEditorialsFromType(this.props.typeId);
		}
	}

	componentWillUpdate(nextProps) {

		if (this.props.editorials.editorialsByType && this.props.editorials.editorialsByType[0].types.id !== nextProps.editorials.editorialsByType[0].types.id) {
			this.editorialsByType = [];
		}

		if (this.error || this.editorialsByType.length <= 1 || !this.props.editorials.editorialsByType || this.state.clearData) {
			let _this = this;
			this.editorialsByType = [];
			this.error = false;

			this.state.clearData = false;

			forEach(nextProps.editorials.editorialsByType, function(single) {
				_this.editorialsByType.push(single);
			});
		} else if (nextProps.editorials.editorialsByType && nextProps.editorials.editorialsByType[0].id !== this.props.editorials.editorialsByType[0].id && nextProps.editorials.editorialsByType[0].id !== this.editorialsByType[0].id) {
			let _this = this;

			forEach(nextProps.editorials.editorialsByType, function(single) {
				_this.editorialsByType.push(single);
			});
		}

		if (nextProps.editorials.error) {
			this.editorialsByType = [];
			this.error = true;
			this.editorialsByType.push(nextProps.editorials.error);
		}
	}

	componentWillUnmount() {
		document.querySelector('body').classList.remove('context-active');
	}

	componentWillReceiveProps(nextProps) {
		this.state.searched = false;
		if (nextProps.typeId !== this.props.typeId) {
			this.editorialsByType = [];
			this.fetchEditorialsFromType(nextProps.typeId);
		}
	}

	componentDidUpdate() {
		this.busy = false;

		if(this.state.active) {
			let name = this.props.name + '-seen';
			if (!localStorage.getItem(name)) {
				localStorage.setItem(name, 'seen');
			}
			this.introHidden = true;
		}

		if (this.refs.editorialsHolder) {
			let last = this.refs.editorialsHolder.lastChild;

			let target = document.querySelector('.contextual-editorials__news__news-single');
			if (!target) {
				return;
			}

			let startRow =  Math.round(this.refs.editorialsHolder.scrollTop / target.offsetHeight);
			let noRows =  Math.round(this.refs.editorialsHolder.offsetHeight / target.offsetHeight);
			let columns =  Math.round(this.refs.editorialsHolder.offsetWidth / target.offsetWidth);
			let start = ((startRow * columns == 0) ? 1 : startRow * columns);
			let end = start + noRows * columns;
			end = ((start == 1) ? end - 1 : end);

			if (this.props.editorials.totalEditorials < end) {
				end = this.props.editorials.totalEditorials;
			}

			if (start !== this.state.start || end !== this.state.end) {
				this.setState({
					start: start,
					end: end,
				});
			}
		}

		if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
			this.refs.search.focus();
			this.firstLaunch = false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState !== this.state ||
			nextProps !== this.props ||
			nextProps.typeId !== this.props.typeId ||
			nextProps.enableNews !== this.props.enableNews
		);
	}

	render() {
		let news = null;
		let profiles = null;
		let allNews = null;
		let newsNum = null;
		let searchWord = null;
		let searchResults = null;
		let total = null;
		let thisNews = null;
		let next = null;
		let prev = null;
		this.extraClass = '';

		let localName = this.props.name + '-seen';
		let showIntro = false;

		if (this.props.intro && this.props.browser.window.width > 719 && !localStorage.getItem(localName) && !this.state.active) {
			this.extraClass = ' intro';
			showIntro = true;
		}

		if (this.props.editorials && this.props.editorials.editorialsByType && this.props.editorials.editorialsByType.length) {
			news = this.props.editorials.editorialsByType;
			allNews = this.state.start + ' — ' + this.state.end;
			newsNum = news.length;
			searchWord = this.state.searchWord;
			searchResults = [];
			total = newsNum;
			thisNews = this.props.interviewId;
			next = 0;
			prev = 0;
		}

		let startYear = 2000;
		let endYear = new Date().getFullYear();

		if (this.props.editorials && this.props.editorials.firstEditorial) {
			startYear = this.props.editorials.firstEditorial.split('-')[0];
		}

		this.years = [];

		let yearsNum = endYear - startYear;

		for (let i = endYear; i >= startYear; i--) {
			let local = {
				label: i,
				value: i,
			};
			this.years.push(local);
		}


		let nextClass = 'span2 span4-mobile contextual-menu__next';
		let prevClass = 'span2 span4-mobile contextual-menu__prev';
		let toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
		let buttonClass = 'contextual-menu__toggle__button';
		let innerClass = 'contextual-menu__inner span14';
		let controlClass = 'contextual-menu__control span14';

		if (this.state.active) {
			nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
			prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
			toggleClass += ' contextual-menu__toggle--active';
			buttonClass += ' contextual-menu__toggle__button--active';
			innerClass += ' contextual-menu__inner--active';
			controlClass += ' contextual-menu__control--active';
		}

		if (this.props.seen || this.state.active) {
			controlClass += ' contextual-menu__control--seen'
		}

		return (
			<section className='contextual-menu span14'>
				<div className={controlClass + this.extraClass}>
					{showIntro && (
					<div className='contextual-menu__intro hide-mobile'>{this.props.intro}</div>
					) || null}
					<div className='contextual-menu__control__top'>
						{this.props.prev && (
							<Link onClick={(event) => this.onLinkClick(event)} to={generateURL(this.props.typeSlug, this.props.prev)}>
							<div className={prevClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
							</div>
							</Link>
						) || (
							<div className={prevClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
							</div>
						)}
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						<div className={toggleClass}>
							<button ref='contextualToggle' className={buttonClass} onClick={(event) => this.onClick(event)}>
								<div className='burger-icon'>
									<span><i></i></span>
									<span><i></i></span>
									<span><i></i></span>
								</div>
								<div className='close-icon'>
									<span><i></i></span>
									<span><i></i></span>
								</div>
							</button>
						</div>
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						{this.props.next && (
							<Link onClick={(event) => this.onLinkClick(event)} to={generateURL(this.props.typeSlug, this.props.next)}>
							<div className={nextClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
							</div>
							</Link>
						) || (
							<div className={nextClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
							</div>
						)}
					</div>
					{!this.props.seen && (
					<span className='contextual-menu__control__text'>Discover more</span>
					)}
				</div>
				<div ref='contextualInner' className={innerClass}>
				{this.props.editorials.editorialsByType && this.props.editorials.editorialsByType.length && (
					this.renderNews(this.editorialsByType, newsNum, allNews, total)
				) || null}
				</div>
			</section>
		);
	}

	renderNews(news, newsNum, allNews, total) {
		let uid = 'contextNews';

		let spinnerClass = 'contextual-menu__inner-list__cases__spinner';

		if (this.state.searched) {
			spinnerClass = 'contextual-menu__inner-list__cases__spinner contextual-menu__inner-list__cases__spinner--active';
		}

		let selectClass = 'contextual-menu__inner-list__filters span4 hide-mobile hide-tablet hide-desktop';
		let inputClass = 'contextual-menu__inner-list__search span12-plus hide-mobile';
		let rightClass = 'span2-plus contextual-menu__inner-list__right hide-mobile';

		if (this.props.dateFilter == 1) {
			selectClass = 'contextual-menu__inner-list__filters span4-plus span6-tablet-plus span14-mobile-plus';
			inputClass = 'contextual-menu__inner-list__search span8 hide-mobile';
			rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--date hide-mobile';
		}

		if (this.props.seen || this.state.active) {
			rightClass += ' contextual-menu__inner-list__right--seen';
		}

		return (
			<article key={uid} className='contextual-menu__inner-list span14'>
				<div className='contextual-menu__inner-list__top span14'>
					<h1 className='contextual-menu__inner-list__top__title'>{this.props.name}</h1>
					<span className='contextual-menu__inner-list__top__number'> ({this.props.editorials.totalEditorials})</span>
				</div>
				<div className={selectClass}>
					<Select
						onChange={(event) => this.dateInput(event)}
						name=''
						ref='yearInput'
						placeholder='Year'
						className='contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--year'
						options={this.years} />
					<Select
						onChange={(event) => this.dateInput(event)}
						name=''
						ref='monthInput'
						placeholder='Month'
						className='contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--month'
						options={[{label: 'January', value: 1,},{label: 'February', value: 2,},{label: 'March', value: 3,},{label: 'April', value: 4,},{label: 'May', value: 5,},{label: 'June', value: 6,},{label: 'July', value: 7,},{label: 'August', value: 8,},{label: 'September', value: 9,},{label: 'October', value: 10,},{label: 'November', value: 11,},{label: 'December', value: 12,}]} />
				</div>
				<input ref='search' onChange={(event)=>this.onInput(event)} className={inputClass} type='text' placeholder={translate('contextual/editorialSearch')} />
				<ul onScroll={(event) => this.scrollEvent(event)} ref='editorialsHolder' className={'contextual-menu__inner-list__items span12-scroll span14-mobile'}>
					<li ref='profileSpinner' className={spinnerClass}>
						<Spinner pathStroke='#fff' className='profile-list__table__spinner__spinner' size='80px'></Spinner>
					</li>
					{this.error && (
						this.editorialsByType.map((single, i) => this.renderError(single, i))
					) || (
						this.editorialsByType.map((single, i) => this.renderSingle(single, i))
					)}
				</ul>
				<div className={rightClass}>
					<span className='contextual-menu__inner-list__right__byline'>showing</span>
					<h2 className='contextual-menu__inner-list__right__title'>{allNews}</h2>
					<span className='contextual-menu__inner-list__right__number'>{this.props.editorials.total + ' in total'}</span>
				</div>
			</article>
		);
	}

	renderError(single, i) {
		let uid = 'contextualJob' + i;

		return (
			<li key={uid} className='contextual-menu__inner-list__cases__case span2 span4-tablet span14-mobile'>
				<div className='contextual-menu__inner-list__cases__case__content'>
					<h2 className='contextual-menu__inner-list__cases__case__title'>{single.title}</h2>
					<span className='contextual-menu__inner-list__cases__case__byline'>{single.message}</span>
				</div>
			</li>
		);
	}

	renderSingle(single, i) {
		let uid = 'contextualJob' + i;
		let date = new DateFormatter(single.releaseDate || single.createdDate);
		date = date.date + ' ' + date.month + ' ' + date.year;
		let url = generateURL(single.types.slug, single.slug);

		return (
			<li key={uid} className='contextual-editorials__news__news-single contextual-editorials__news__news-single--contextual span4 span6-tablet span14-mobile'>
				<h2 className='contextual-editorials__news__news-single__title contextual-editorials__news__news-single__title--contextual span3 span5-tablet span12-mobile'>{single.title}</h2>
				{single.users && single.users.name && (
					<span className='contextual-editorials__news__news-single__profile'>{'By ' + single.users.name}</span>
				)}
				{!!(single.releaseDate || single.createdDate) && (
					<span className='contextual-editorials__news__news-single__date contextual-editorials__news__news-single__date--contextual'>{date}</span>
				)}
				{single.slug && this.props.browser.window.width > 719 && (
					<div className='contextual-editorials__news__news-single__overlay contextual-editorials__news__news-single__overlay--contextual'><Link onClick={(event) => this.onLinkClick(event)} to={url} className='button contextual-editorials__news__news-single__button'>Read more</Link></div>
				) || single.slug && (
					<Link onClick={(event) => this.onLinkClick(event)} to={url} className='contextual-editorials__news__news-single__button--fill'></Link>
				)}
			</li>
		);
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	dateInput(e) {
		let month = this.refs.monthInput.value;
		let year = this.refs.yearInput.value;

		this.refs.editorialsHolder.scrollTop = 0;

		this.fetchEditorialsFromType(this.props.typeId, 0, 36, month, year, this.query);

		this.setState({
			searched: true,
			clearData: true,
		});
	}

	onInput(e) {
		e.preventDefault();
		let _this = this;
		this.query = e.target.value;
		let m = this.refs.monthInput.value;
		let y = this.refs.yearInput.value;

		this.refs.editorialsHolder.scrollTop = 0;

		clearTimeout(this.inputTimeout);

		this.inputTimeout = setTimeout(function() {
			_this.fetchEditorialsFromType(_this.props.typeId, 0, 36, m, y, _this.query);
			_this.setState({
				searched: true,
				clearData: true,
			});
		}, 400);
	}

	scrollEvent(e) {
		let last = e.target.lastChild;

		let target = document.querySelector('.contextual-editorials__news__news-single');

		let startRow =  Math.round(e.target.scrollTop / target.offsetHeight);
		let noRows =  Math.round(e.target.offsetHeight / target.offsetHeight);
		let columns =  Math.round(e.target.offsetWidth / target.offsetWidth);
		let start = ((startRow * columns == 0) ? 1 : startRow * columns);
		let end = start + noRows * columns;
		end = ((start == 1) ? end - 1 : end);

		this.setState({
			start: start,
			end: end,
		});

		if (last.offsetTop - e.target.scrollTop < 1200 && !this.busy) {
			this.busy = true;

			let params = null;
			let type = this.props.typeId;
			let offset = '';
			let month = '';
			let limit = '';
			let year = '';
			let query = '';

			if (this.props.editorials.nextType) {
				params = this.props.editorials.nextType.split('&');

				offset = params[1].split('=')[1];

				if (params[2]) {
					limit = params[2].split('=')[1];
				}

				if (params[3]) {
					month = params[3].split('=')[1];
				}

				if (params[4]) {
					year = params[4].split('=')[1];
				}

				if (params[5]) {
					query = params[5].split('=')[1];
				}

				this.fetchEditorialsFromType(type, offset, limit, month, year, query);
			}
		}
	}

	onLinkClick(e) {
		document.querySelector('body').classList.remove('context-active');

		this.setState({
			active: false,
		});
	}

	onClick(e) {
		e.preventDefault();
		document.querySelector('body').classList.toggle('context-active');

		try {
			localStorage.setItem('context', 'seen');
		} catch (e) {}

		this.setState({
			active: !this.state.active,
		});
	}
}

export default connect(ContextualDefault);



/** WEBPACK FOOTER **
 ** ./frontend/components/contextual/contextualDefault.js
 **/